// extracted by mini-css-extract-plugin
export default {"titlePadding":"summaryAndSending_titlePadding__nBsoZ","valueText":"summaryAndSending_valueText__8SW9G"};